<template>
  <v-card class="blue-grey lighten-5">
    <v-overlay :value="playerStatus === 'ready'" absolute />

    <v-card-title
      :class="isConnected ? 'accent--text' : 'secondary--text'"
      class="headline justify-center"
      v-text="playerName"
    />

    <v-card-text class="text-center">
      <template v-if="isFinished">
        <div class="mx-3 mb-4">
          <p
            class="py-1 my-1 rounded white lighten-1 text-center subtitle-2 primary--text"
            v-text="timePlayed"
          />
          <p
            class="py-1 my-1 rounded white lighten-1 text-center subtitle-2 error--text"
            v-text="numberOfMistakes"
          />
        </div>
        <v-btn
          :loading="loading"
          color="accent"
          small
          block
          @click="restartGame"
        >
          <span v-text="$t('animation.multitask.restartGame')" />
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>

      <template v-else>
        <div
          :class="playerStatus === 'playing' ? 'success' : 'accent'"
          class="mt-3 mb-2 py-3 rounded-pill subtitle-1 white--text lighten-1"
          v-text="$t(`animation.multitask.status.${playerStatus}`)"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PlayerCard',
  props: {
    value: {
      type: Object,
      required: true,
    },
    scoreKey: {
      type: String,
      default: '',
    },
  },
  inject: [
    'sendPlayerAction',
  ],
  data: () => ({
    loading: false,
  }),
  computed: {
    playerId () {
      return this.value.id
    },
    isConnected () {
      return this.value.playerName
    },
    playerName () {
      return this.isConnected
        ? this.value.playerName
        : this.$t('animation.multitask.notPlayerName')
    },
    playerStatus () {
      return this.value.status
    },
    isFinished () {
      return this.value.status === 'finished'
    },
    timePlayed () {
      const { timePlayed } = this.scoreKey ? this.value[this.scoreKey] : this.value
      return this.$tc('animation.multitask.timePlayed', timePlayed, { timePlayed })
    },
    numberOfMistakes () {
      const { numberOfMistakes } = this.scoreKey ? this.value[this.scoreKey] : this.value
      return this.$tc('animation.multitask.numberOfMistakes', numberOfMistakes, { numberOfMistakes })
    },
  },
  methods: {
    async restartGame () {
      this.loading = true
      await this.sendPlayerAction(this.playerId, 'restartGame')
      this.loading = false
    },
  },
}
</script>
